<template>
  <div class="new-ui">
    <div class="auth-page">
      <span class="auth-page__logo-wrap">
        <img :src="logo" alt="Obiado logo" class="auth-page__logo" />
      </span>

      <h1 v-if="title" class="auth-page__title">{{ title }}</h1>

      <div class="auth-card" :class="{ 'auth-card--wide': wide }">
        <slot />
      </div>

      <div class="auth-page__language">
        <LanguageSwitcher with-label />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";

withDefaults(
  defineProps<{
    title?: string;
    wide?: boolean;
  }>(),
  {
    title: undefined,
    wide: false,
  },
);

const logo = "/img/obiado.svg";

onMounted(() => {
  document.body.classList.add("new-ui");
});

onBeforeUnmount(() => {
  document.body.classList.remove("new-ui");
});
</script>
